import { Reveal } from "./Reveal";
import { FrenchFlag } from "./FrenchFlag";
import { useLang } from "../i18n";

export const FrenchSeries = () => {
    const { t } = useLang();
    const items = t("french.items");
    return (
        <section id="french-series" className="bg-ivory pt-28 sm:pt-40 pb-6 px-6 sm:px-10" data-testid="french-series-intro">
            <div className="max-w-7xl mx-auto text-center">
                <Reveal>
                    <p className="text-xs tracking-[0.35em] uppercase text-golddark mb-6 flex items-center justify-center gap-3">
                        {t("french.overline")} <FrenchFlag />
                    </p>
                    <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight text-charcoal" data-testid="french-series-heading">
                        {t("french.heading")}
                    </h2>
                    <p className="mt-6 max-w-xl mx-auto text-sm sm:text-base text-smoke leading-relaxed">{t("french.body")}</p>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-gold/25 border border-gold/25 max-w-5xl mx-auto">
                        {items.map((item) => (
                            <div key={item.n} className="bg-ivory px-6 py-8" data-testid={`series-index-${item.n}`}>
                                <span className="font-serif text-3xl text-gold">{item.n}</span>
                                <p className="font-serif text-xl text-charcoal mt-3">{item.name}</p>
                                <p className="text-[11px] tracking-wide text-ash mt-2">{item.hint}</p>
                                <p
                                    className={`text-[9px] tracking-[0.25em] uppercase mt-4 ${item.available ? "text-golddark" : "text-ash"}`}
                                    data-testid={`series-status-${item.name.toLowerCase().replace(/\s/g, "-")}`}
                                >
                                    {item.available ? t("french.available") : t("french.comingSoon")}
                                </p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
